import {InjectionToken} from '@angular/core';

export const BIM_CONFIG = new InjectionToken('mydocma-bim-config');

export interface BimConfig {
  bpApiUrl: string;
}
